// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"2c688fcc","122":"72bbac68","256":"36e64aa5","398":"488288ed","420":"7b98e7f0","662":"a64bdd97","700":"1a15cb39","844":"9c927c90","902":"63e34670"}[chunkId] + ".chunk.js";
};